import { TEnv } from '../typings/util';
import { parseQueryString } from '../util/uri';

/// 仅定义助手名称, 对应的string是传入的cGameId
export enum HelperName {
  UnKnow = '',
  CHZSNizhan = '10012',
  CHZSTXYouxi = '1002',
  CHZSTiandao= '10002',
  CHZSXuanwuShidai = '10021',
  CHZSQQXuanwu = '10020',
  CHZSQQFeiche = '1003',
  CHZSDNF = '1006',
  CHZSCF = '1001',
}
/**
 * Url的公共参数
 * 用于数据上报和渠道判断
 * 页面跳转和url分享时，需要透传所有公共参数
 */
export const UrlCommonParam: {[key: string]: string} = {
  channel: 'c-channel', // 渠道类型：闪现: CHShanxian、公众号:WXOfficial、小程序：WXMiniApp、系统浏览器: System
  channelName: 'c-channel-name', // 渠道名称：如公众号的名称、小程序的名称
};

/// 所有channel配置， c-channel有其他的特殊类型可以加上
const channelConfig = {
  helperChannels: ['ZSNizhan'],
};

// 获取IOS版本号
const getIOSVersion = (ua: string) => {
  const regexp = /.*\s+com\.tencent\.gamecommunity\/(\S+)\s+.*/ig;
  if (ua && regexp.test(ua)) {
    // ua = 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_3 like Mac OS X) AppleWebKit/605.1.15
    // (KHTML, like Gecko) Mobile/15E148 com.tencent.gamecommunity/1.1.0.1.1.1sss ENV/TEST SUB/0 Scale/2.00'
    return ua.replace(regexp, '$1').replace(/([^\d.])/g, '');
  }
  return '';
};

const query = parseQueryString(location.search);

// 获取Android版本号
const getAndroidVersion = (ua: string) => {
  const regexp = /.*\s+VERSION_NAME\/(\S+)\s+.*/ig;
  if (ua && regexp.test(ua)) {
    // ua = 'ENV/TEST BUNDLEID/com.tencent.gamecommunity CHANNEL/DevOps VERSION_NAME/1.1.0.2 VERSION_CODE/2 SUB/0'
    return ua.replace(regexp, '$1').replace(/([^\d.])/g, '');
  }
  return '';
};

const checkHelperChannel = (): boolean => {
  const cChannel = String(query[UrlCommonParam.channel]);
  if (-1 !== channelConfig.helperChannels.indexOf(cChannel)) {
    return true;
  }
  return false;
};

const getHelperName = (ua: string): HelperName => {
  const matchArr = ua.match(/GameHelper_(\d+)\//);
  let cGameId = '';
  if (matchArr?.length) {
    cGameId = matchArr[1] as string;
  }
  switch (cGameId) {
    case HelperName.CHZSTXYouxi:{
      return HelperName.CHZSTXYouxi;
    }
    case HelperName.CHZSNizhan:{
      return HelperName.CHZSNizhan;
    }
    case HelperName.CHZSTiandao:{
      return HelperName.CHZSTiandao;
    }
    case HelperName.CHZSQQXuanwu:{
      return HelperName.CHZSQQXuanwu;
    }
    case HelperName.CHZSXuanwuShidai:{
      return HelperName.CHZSXuanwuShidai;
    }
    case HelperName.CHZSQQFeiche:{
      return HelperName.CHZSQQFeiche;
    }
    case HelperName.CHZSDNF:{
      return HelperName.CHZSDNF;
    }
    case HelperName.CHZSCF:{
      return HelperName.CHZSCF;
    }
    default: return HelperName.UnKnow;
  }
};

export function checkEnv(): TEnv {
  const ua = window.navigator.userAgent;
  const isTest = window.location.host !== 'm.gameplus.qq.com' && window.location.host !== 'm.noknok.cn' && window.location.host !== 'app.noknok.cn';
  const iOS = new RegExp('\\(i[^;]+;( U;)? CPU.+Mac OS X', 'i').test(ua);
  const android = /Android/i.test(ua) || /Linux/i.test(ua);
  const isWeixin = /MicroMessenger/i.test(ua); // 是否微信打开
  const isWXMiniprogram = isWeixin && /miniProgram/i.test(ua);
  const isHelper = /GameHelper/i.test(ua); // 是否助手内打开
  let helperName;
  /// 是助手内需要区分是哪个助手
  if (isHelper) {
    helperName = getHelperName(ua);
  }
  const isMNA = /MnaVersion/i.test(ua); // 是否在MNA中打开
  const isHelperChannel = checkHelperChannel(); // 是否助手渠道，主要区分外部浏览器打开
  const lowerPlatformBefore = navigator.platform?.toLowerCase() ?? '';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const lowerPlatformNow = navigator.userAgentData?.platform?.toLowerCase() ?? '';
  const isMac = lowerPlatformBefore.indexOf('mac') > -1 || lowerPlatformNow.indexOf('mac') > -1;
  const isWindows = lowerPlatformBefore.indexOf('win') > -1 || lowerPlatformNow.indexOf('windows') > -1;
  let appVersion = '';
  if (android) {
    appVersion = getAndroidVersion(ua);
  } else if (iOS) {
    appVersion = getIOSVersion(ua);
  }
  // 判断是否是奇游app
  const cChannel = String(query[UrlCommonParam.channel]);
  let isQiyouApp = false;
  if (cChannel === 'CHQiyou') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const expression = window?.UserCenter?.closeWeb || window?.webkit?.messageHandlers?.closeWeb;
    if (expression) isQiyouApp = true;
  }
  const result = {
    isSXApp: /com\.tencent\.gamecommunity/.test(ua),
    isKKApp: /com\.kknock/.test(ua),
    mobile: /AppleWebKit.*Mobile.*/i.test(ua),
    windowsPhone: /Windows Phone/i.test(ua),
    iOS,
    android,
    appVersion,
    isProd: !isTest,
    isTest,
    isWeixin,
    isWXMiniprogram,
    isHelper,
    helperName,
    isMNA,
    isHelperChannel,
    isMac,
    isWindows,
    isQiyouApp,
  };
  if (result.iOS && result.android) {
    result.iOS = false; // 部分Android机可能会把自己伪装成iOS
  }
  return result;
}

export const env = checkEnv();

export default {
  checkEnv,
  env,
};
